import getSelectedLocationName from '../getSelectedLocationName';
import { regionCodes } from '../../referenceData';
import getSubjectColor from '../getSubjectColor';
import getAvgScoreForGroup from '../getAvgScoreForGroup';
import getCountriesInGroup from '../getCountriesInGroup';
import isACountry from '../isACountry';

export default (state, subject, locations, years, groupHighlight) =>
  locations.map((location) => {
    let data = [];
    const subjectColor = getSubjectColor({ state, subject });
    const secondarySubjectColor = getSubjectColor({ state, subject, sec: true });

    const countriesInGroup = [];
    if (groupHighlight) {
      countriesInGroup.push(...getCountriesInGroup(state, groupHighlight.uid).map((c) => c.iso));
    }

    if (!isACountry(location)) {
      data = years.map((year) => getAvgScoreForGroup(state, subject, year, location));
    } else {
      // Keep as raw numbers for Chart.js data - formatting happens in tooltips
      data = years.map((year) => Number(state?.indexedYml[year][subject][location]?.v));
    }
    data = data.map((v) => (v > -1 ? v : null));

    return {
      label: getSelectedLocationName(state, location),
      backgroundColor: subjectColor,
      hoverBackgroundColor: subjectColor,
      borderColor: groupHighlight && countriesInGroup.includes(location) ? subjectColor : `rgb(140,140,140)`, // eslint-disable-line i18next/no-literal-string
      subjectColor,
      borderWidth: 2,
      hitRadius: 10,
      pointRadius: (pointData) => (pointData.dataIndex !== data.length - 1 ? 0 : 8),
      pointHoverRadius: 8,
      pointBorderWidth: 1,
      pointBorderColor: 'rgb(140,140,140)',
      pointBackgroundColor: subjectColor,
      data,
      tooltip: {
        order: 1,
      },
    };
  });
